import PropTypes from 'prop-types';
import { StorePropType } from '../prop-types/store';

export const OrderPropType = PropTypes.shape({
  salesOrderItemId: PropTypes.string,
  orderNumber: PropTypes.string,
  store: StorePropType,
});

/**
 * @typedef {object} OrderPropType
 * @property {string} salesOrderItemId
 * @property {string} orderNumber
 * @property {StorePropTypes} store
 */
